module.exports = __webpack_public_path__ + "img/pro_jinniao_06.d18fbdbc.png";